import { addToCartButtons } from './product-card';

class UpsellProductsDrawer extends HTMLElement {
  constructor() {
    super();
    const productId = Number(this.dataset.productId);
    const productHandle = this.dataset.productHandle;
    this.addToCartLabel = this.dataset.addToCartLabel;
    this.whiteBackgroundRemover = this.dataset.whiteBackgroundRemover;

    // Assuming 'this' is an instance of UpsellProducts, e.g. inside a method of the class
    this.getUpsellProductsDataFromMetafield(productHandle).then((upsellData) => {
      if (upsellData) {
        if (upsellData == '') {
          this.getUpsellProducts(productId);
        } else {
          this.renderUpsellProducts(JSON.parse(upsellData));
        }
      } else {
        this.getUpsellProducts(productId);
      }
    });
  }

  async getUpsellProductsDataFromMetafield(productHandle: string): Promise<string | null> {
    try {
      const response = await fetch(window.Shopify.routes.root + `products/${productHandle}?view=upsell`);
      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const upsellEl = doc.getElementById('upsell-products-data');
      return upsellEl ? upsellEl.textContent : null;
    } catch {
      return null;
    }
  }

  getUpsellProducts(productId: number) {
    const intent = 'related';

    fetch(
      window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}&intent=${intent}&limit=16`,
    )
      .then((response) => response.json())
      .then((data) => {
        this.renderUpsellProducts(data.products);
      });
  }

  renderUpsellProducts(products) {
    if (!this) return;

    let availableCount = 0;

    products.forEach((product) => {
      if (availableCount >= 8) {
        return;
      }
      if (product?.variants?.[0]?.available == true) {
        let price;
        let compareAtPrice;
        // add supported currencies here
        if (window.Shopify.country == 'SE') {
          price = window.Shopify.formatMoney(product.price, '{{amount_no_decimals}} kr').replace(/,/g, ' ');
          compareAtPrice = product.compare_at_price
            ? window.Shopify.formatMoney(product.compare_at_price, '{{amount_no_decimals}} kr').replace(/,/g, ' ')
            : '';
        } else {
          price = window.Shopify.formatMoney(product.price, '{{amount}} €')
            .replace(/,/g, ' ')
            .replace(/\./g, ',')
            .replace(/,00/, '');
          compareAtPrice = product.compare_at_price
            ? window.Shopify.formatMoney(product.compare_at_price, '{{amount}} €')
                .replace(/,/g, ' ')
                .replace(/\./g, ',')
                .replace(/,00/g, '')
            : '';
        }

        const productCard = document.createElement('div');
        productCard.classList.add('upsell-product-card');
        productCard.classList.add('min-w-[175px]');
        productCard.classList.add('l:min-w-[326px]');
        productCard.classList.add('pb-2x');

        let disabledAttribute = '';
        if (product.variant_available != undefined) {
          disabledAttribute = product.variant_available == true ? '' : 'disabled';
        } else {
          disabledAttribute = product.variants[0].available == true ? '' : 'disabled';
        }

        let variantId = '';
        if (product.variant_id != undefined) {
          variantId = product.variant_id;
        } else {
          variantId = product.variants[0].id;
        }

        const imageHtml = product.featured_image
          ? `<img src="${product.featured_image}" alt="${product.title}" class="${this.whiteBackgroundRemover ? 'mix-blend-multiply' : ''} w-full object-contain aspect-square p-4x">`
          : `<svg class="size-full scale-[1.5]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>`;
        productCard.innerHTML = `
   <article data-product-id="${product.id}" data-layout="vertical" class="
      group relative decoration-none flex flex-col
      data-[layout=horizontal]:min-h-[220px]
      data-[layout=vertical]:h-fit data-[layout=vertical]:w-full
      product-card-container
      ">
      <div data-product-card class="
         flex gap-2x w-full h-full items-center
         group-data-[layout=horizontal]:flex-row
         group-data-[layout=vertical]:flex-col
         ">
         <div class="
            relative shrink-0 rounded-l gap-2.5x bg-secondary flex items-center justify-center h-[220px]
            group-data-[layout=horizontal]:w-40x
            group-data-[layout=vertical]:w-full l:group-data-[layout=vertical]:min-w-[326px] l:group-data-[layout=vertical]:h-[349px]
            overflow-hidden
            ">
            <div class="flex items-center justify-center aspect-square overflow-hidden">
               ${imageHtml}
            </div>
         </div>
         <div class="flex flex-col gap-2x grow h-fit w-full">
            <div class="flex flex-col gap-1x h-fit">
               <a href="/products/${product.handle}" class="after:content-[''] after:inset-0 after:absolute after:z-[1] group/link" title="${product.title}">
                  <h3 style="font-size:14px;" class="line-clamp-1 heading-xs font-small hover:underline group-hover/link:underline">
                     ${product.title}
                  </h3>
               </a>
            </div>
            <div class="flex flex-col gap-4x">
               <div class="flex flex-col gap-0.5x">
                  <div class="flex flex-row gap-1x l:gap-2x items-center">
                     <div class="
                        js-variant-badge
                        ">
                        <span class="heading-xs l:heading-s font-medium js-variant-price">
                        ${price}
                        </span>
                     </div>
                     <span class="body-s l:body-m line-through font-light js-variant-compare-at-price">
                         ${compareAtPrice}
                     </span>
                  </div>
               </div>
               <div class="flex items-center z-[2]">
                <product-form data-section-id="quick-add-${product.id}">
                  <div class="bg-negative-subtle px-2x py-3x space-x-3x items-center hidden mt-4x mb-1x" role="alert" id="error-message-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6x"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" /></svg>
                    <span class="body-s p-[6x]" id="error-message"></span>
                  </div>
                    <form method="post" action="/cart/add" id="quick-add-${product.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${variantId}" class="product-variant-id">
                    <div class="flex items-center z-[3]">
                        <button ${disabledAttribute} class="btn-outline btn-small l:btn-medium btn-pill js-add-to-cart" aria-label="${this.addToCartLabel}" data-product-id="${product.id}" data-variant-id="${variantId}" data-drawer-upsell="true" id="${product.id}-quick-add-submit" type="submit" name="add">
                        <span class="px-1x">+ ${this.addToCartLabel}</span>
                        </button>
                    </div>
                    <input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" value="template--${product.id}__related-products">
                    </form>
                </product-form>
               </div>
            </div>
         </div>
      </div>
</div>
        `;
        this.appendChild(productCard);
        availableCount++;
      }
    });
    addToCartButtons();
    // hide the element if there are no products
    if (availableCount > 0) {
      const upsellProductsEl = document.getElementById('CartDrawer-UpsellProducts');
      if (upsellProductsEl) {
        upsellProductsEl.classList.remove('hidden');
      }
    }
  }
}

customElements.define('upsell-products-drawer', UpsellProductsDrawer);
